import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthProvider';

// Authentication guard component
const RequireAuth = ({ children, redirectTo = '/user-login' }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login page, preserving the intended destination
    return (
      <Navigate 
        to={redirectTo} 
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
        replace 
      />
    );
  }

  return children;
};

export default RequireAuth;
